import type { ReactNode } from "react";

export type TimelineItem = {
  title: string;
  at: string;
  /** `done` and `now` fill the dot and the line below it in the accent colour. */
  state?: "ok" | "warn" | "fail" | "done" | "now";
  detail?: ReactNode;
};

export function Timeline({ items }: { items: TimelineItem[] }) {
  return (
    <div className="tl">
      {items.map((it, i) => (
        <div className={`tl-item ${it.state ?? ""}`.trimEnd()} key={i}>
          <div className="tl-title">{it.title}</div>
          <div className="tl-meta">{it.at}</div>
          {it.detail ? <div className="tl-body">{it.detail}</div> : null}
        </div>
      ))}
    </div>
  );
}
